export interface FillerPreviewSource { url: string; durationSeconds?: number }
export type FillerPreviewSources = Record<string, FillerPreviewSource>;
export interface FillerPreviewRow {
  file_url: string;
  file_en_url?: string | null;
  preview_url?: string | null;
  preview_en_url?: string | null;
  preview_duration_seconds?: number | null;
  preview_en_duration_seconds?: number | null;
}
/** URLs in saved layouts and export payloads stay original; this map is playback-only. */
export function buildFillerPreviewSources(rows: FillerPreviewRow[]): FillerPreviewSources {
  const result: FillerPreviewSources = {};
  for (const row of rows) {
    for (const [source, preview, duration] of [
      [row.file_url, row.preview_url, row.preview_duration_seconds],
      [row.file_en_url, row.preview_en_url, row.preview_en_duration_seconds],
    ] as const) {
      if (source && preview) result[source] = { url: preview,
        ...(typeof duration === 'number' && duration > 0 ? { durationSeconds: duration } : {}) };
    }
  }
  return result;
}
